module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-1.bb5737d5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-1.mp3
// module id = 123
// module chunks = 0